// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M13 13C12.78 13.86 11.97 14.5 11 14.5H5C3.9 14.5 3 13.6 3 12.5V2.99C3 2.17 3.67 1.5 4.49 1.5H6.5C7.2 1.5 7.87 1.61 8.5 1.81C10 2.3 11.26 3.31 12.07 4.64',
  'M8.5 1.81V4.5C8.5 5.6 9.39 6.5 10.5 6.5',
  'M 13.83 8.81 L 14.41 8.23 C 14.71 7.93 14.61 7.36 14.2 6.94 C 13.78 6.53 13.21 6.43 12.91 6.73 L 12.33 7.31 L 9.04 10.6 C 8.87 10.77 8.77 10.99 8.74 11.24 L 8.63 12.28 C 8.62 12.39 8.75 12.52 8.86 12.51 L 9.9 12.4 C 10.15 12.37 10.37 12.27 10.54 12.1 L 13.83 8.81 Z',
  'M5.5 11.7H6.5',
];
